/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RegistrationRequest } from '../models/registration-request';
import { RegistrationStatus } from '../models/registration-status';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiRegistrationPost
   */
  static readonly ApiRegistrationPostPath = '/api/Registration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRegistrationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRegistrationPost$Plain$Response(params?: {
    context?: HttpContext
    body?: RegistrationRequest
  }
): Observable<StrictHttpResponse<RegistrationStatus>> {

    const rb = new RequestBuilder(this.rootUrl, RegistrationService.ApiRegistrationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistrationStatus>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRegistrationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRegistrationPost$Plain(params?: {
    context?: HttpContext
    body?: RegistrationRequest
  }
): Observable<RegistrationStatus> {

    return this.apiRegistrationPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<RegistrationStatus>) => r.body as RegistrationStatus)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRegistrationPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRegistrationPost$Json$Response(params?: {
    context?: HttpContext
    body?: RegistrationRequest
  }
): Observable<StrictHttpResponse<RegistrationStatus>> {

    const rb = new RequestBuilder(this.rootUrl, RegistrationService.ApiRegistrationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistrationStatus>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiRegistrationPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRegistrationPost$Json(params?: {
    context?: HttpContext
    body?: RegistrationRequest
  }
): Observable<RegistrationStatus> {

    return this.apiRegistrationPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<RegistrationStatus>) => r.body as RegistrationStatus)
    );
  }

}
